<div [ngClass]="layout.config.settings.layout_type+' '+layout.config.settings.layout_version">
  <div class="page-wrapper">
    <div class="dark-body-only" id="outer-container">
      <!-- page-wrapper Start -->
      <div class="page-wrapper" [ngClass]="!navServices.horizontal ? 'default' : layout.config.settings.sidebar"
        id="canvas-bookmark">
        <app-header (rightSidebarEvent)="rightSidebar($event)"></app-header>
        <!-- Page Body Start-->
        <div class="page-body-wrapper">
          <div class="iconsidebar-menu" id="pages-sidebar"
            [ngClass]="{'iconbar-mainmenu-close': navServices.collapseSidebarMainMenu }"
            [class.iconbar-second-close]="navServices.collapseSidebarSecondMenu">
            <app-sidebar></app-sidebar>
          </div>
          <div class="right-sidebar mb-4" [class.show]="right_side_bar" id="right_side_bar">
            <!-- <app-right-sidebar></app-right-sidebar> -->
          </div>
          <div class="page-body" [ngClass]="{'questionnarie-route': !shouldShowNavbar()}">
            <main class="contant">
              <router-outlet #o="outlet"></router-outlet>
            </main>
          </div>
          <!-- footer start-->
          <footer class="footer" style="background-image: url(../../../../../assets/images/bg_img.png);">
            <app-footer></app-footer>
          </footer>
          <!-- footer End-->
        </div>
      </div>
      <!-- Page Body End-->
      <!-- page-wrapper End-->
    </div>
  </div>
</div>